import React, {Component} from "react";
import {Grid} from "react-bootstrap";
import UrlsContainer from "../../../components/gtm/UrlsContainer.jsx";
import {API} from "../../../lib/API";
import ModalDialog from "../../../components/common/ModalDialog";
import KnoaBreadcrumb from "../../../components/common/KnoaBreadcrumb";
import {mauiRoutes} from "../../../routes";
import {withTranslation} from 'react-i18next';
import Spinner from "../../../components/common/Spinner";
import {Redirect} from "react-router-dom";
import {getErrorMessagesFromCode, getErrorMsgFromStatus, getInfoMessages} from "../../../lib/messageHandler";
import {Helmet} from "react-helmet";

const localStorage = require('../../../lib/localStorage');

class AdminUrlConfigurationPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allMappings: [],
            discovered: 0,
            showModal: false,
            fetchInProgress: "false",
            showLoggedoutModal: false,
            sessionTerminated: false
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.updateAllMappings = this.updateAllMappings.bind(this);
    }

    handleShow(e) {
        e.preventDefault();

        this.setState({
            showModal: true
        });
    }

    handleClose() {
        this.setState({
            showModal: false
        });
    }

    updateAllMappings(mappings) {
        this.setState({
            allMappings: mappings
        });
    }

    componentDidMount() {
        const _this = this;
        API.admin
            .get("/admin/gtm/configuration/app/mapping")
            .then(resp => {
                const {data} = resp.data;
                console.log(data)
                _this.setState({
                    allMappings: data.mappings,
                    discovered: data.applicationLevels
                });
            })
            .catch(e => {
                console.error(e);
                if (localStorage.get("accessDenied401") === "true") {
                    _this.setState({showLoggedoutModal: true});
                    return;
                }
                let resultCode = -1;
                if (e.data) {
                    resultCode = e.data.resultCode;
                }
                if (e.status === 401 || resultCode === 6007)
                    window.location.href = "/#/auth/logout"
                if (resultCode > -1)
                    _this.props.handleAlertClick("error", "tc", getErrorMessagesFromCode(_this.props.t, resultCode, true));
                else
                    _this.props.handleAlertClick("error", "tc", getErrorMsgFromStatus(_this.props.t, e, true));
            });
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState({allMappings: [],});
        this.setState({discovered: 0,});
    }


    render() {
        if (this.state.sessionTerminated)
            return <Redirect to={{pathname: '/auth/logout'}}/>;

        let routes = mauiRoutes.getRoutes();
        const {t} = this.props;

        return (
            <div className="main-content">
                <Helmet>
                    <title>Knoa Analytics - Task Mining Configuration</title>
                </Helmet>
                <Grid fluid>
                    <KnoaBreadcrumb
                        href="#/admin/AllSettings"
                        firstLevelText={t("common:settings")}
                        secondLevelText={(this.props.navVarBrand) ? this.props.navVarBrand : this.props.getActiveRoute(routes, t)}
                    />
                    <ModalDialog
                        showModal={this.state.showLoggedoutModal}
                        title={"Log Out"}
                        contentBody={
                            <span>{getInfoMessages(this.props.t, 'logoutfor401',null,null)}</span>
                        }
                        bodyPaddingBottom='15px'
                        footerBtnBsStyle="success"
                        footerBtnClass="KnoaSuccessButton"
                        footerBtnOnClick={this.handleLogoutConfirm}
                        footerBtnText={this.props.t('common:ok')}
                    />
                    {this.state.fetchInProgress === "true" && <Spinner/>}
                    <div hidden={this.state.fetchInProgress === "true"}>
                        {(Object.keys(this.state.allMappings).length > 0) &&
                        <UrlsContainer
                            title={t("gtm:title")}
                            allMappings={this.state.allMappings}
                            discovered = {this.state.discovered}
                            handleShow={this.handleShow}
                            handleAlertClick={this.props.handleAlertClick}
                            updateAllMappings={this.updateAllMappings}
                        />
                        }
                    </div>
                </Grid>
            </div>
        );
    }
}

export default  withTranslation()(AdminUrlConfigurationPage);